import React from 'react';
import { Search } from 'lucide-react';
import { useLang } from '../../i18n/LanguageContext';

export const PageHero = ({ image, BadgeIcon, badge, title, highlight, rest, desc, placeholder, searchLabel, query, onQuery, onSubmit, testId = 'page-hero' }) => {
  const { isRTL } = useLang();
  const mask = `linear-gradient(to ${isRTL ? 'right' : 'left'}, black 55%, transparent 100%)`;
  return (
    <section data-testid={testId} className={`relative rounded-[28px] border border-blue-100 bg-gradient-to-br from-blue-50 via-white to-sky-50 shadow-sm ${onSubmit ? 'mb-8 sm:mb-9' : 'mb-6'}`}>
      <div className="absolute inset-0 rounded-[28px] overflow-hidden pointer-events-none">
        <div className="absolute inset-0 hero-grid opacity-40" />
        <img src={image} alt="" data-testid={`${testId}-image`}
          className="hidden lg:block absolute inset-y-0 end-0 h-full w-[62%] object-cover object-center art-reveal"
          style={{ WebkitMaskImage: mask, maskImage: mask }} />
      </div>
      <div className={`relative grid lg:grid-cols-2 items-center gap-6 px-6 sm:px-12 pt-10 ${onSubmit ? 'pb-16 lg:pb-14' : 'pb-10'}`}>
        <div className="art-reveal">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-blue-100/70 text-blue-700 text-xs sm:text-sm font-bold mb-6">
            <BadgeIcon className="w-4 h-4" />{badge}
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-[2.75rem] font-black text-slate-900 tracking-tight mb-3">{title}</h1>
          <p className="text-xl sm:text-2xl lg:text-3xl font-extrabold text-slate-900 mb-4 leading-snug">
            <span className="text-blue-600">{highlight}</span> {rest}
          </p>
          <p className="text-slate-500 text-sm sm:text-base max-w-md leading-relaxed">{desc}</p>
        </div>
        <div className="h-44 sm:h-56 lg:h-[260px]"><img src={image} alt="" className="lg:hidden w-full h-full object-contain rounded-2xl" /></div>
      </div>
      {onSubmit && <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }} data-testid={`${testId}-search-form`}
        className="absolute left-1/2 -translate-x-1/2 -bottom-7 w-[calc(100%-2rem)] max-w-xl flex items-center gap-2 bg-white rounded-2xl shadow-xl shadow-blue-900/10 border border-slate-100 p-2">
        <Search className="w-5 h-5 text-slate-400 ms-2 shrink-0" />
        <input data-testid={`${testId}-search-input`} value={query} onChange={(e) => onQuery(e.target.value)} placeholder={placeholder}
          className="flex-1 min-w-0 h-11 bg-transparent outline-none text-slate-800 placeholder:text-slate-400 text-sm sm:text-base" />
        <button data-testid={`${testId}-search-btn`} type="submit" className="h-11 px-6 sm:px-8 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-bold transition-colors">
          {searchLabel}
        </button>
      </form>}
    </section>
  );
};
